export default {
  SAVE_SHIPPING: 'SAVE_SHIPPING',
};
